<div class="container row">
    <div class="col-12 d-flex flex-row justify-content-between align-items-center">
        <div class="apartado-item-head-opt">
            <span class="gl-text-primary">{{ 'CONFIGURATION.SECTIONS.PREFERENCES.LANGUAGE_CONFIGURATION.TITLE' |
                translate }}</span>
            <p class="gl-text-secondary">
                {{ 'CONFIGURATION.SECTIONS.PREFERENCES.LANGUAGE_CONFIGURATION.DESCRIPTION' | translate }}
            </p>
        </div>
        <div>
            <p-dropdown [(ngModel)]="lenguageSelected" (onChange)="selectLenguage()" [options]="lenguagesOptions"
                optionLabel="name" optionValue="value"></p-dropdown>
        </div>
    </div>
</div>